module.exports = __webpack_public_path__ + "fonts/iconfont.2ed6b91b.woff";